import React from 'react';
import PropTypes from 'prop-types';
import { throttle } from 'lodash';
import styles from './styles.module.styl';
import CopyButton from './CopyButton';
import FeedbackSection from './FeedbackSection';
import CodeHighlight from '../CodeHighlight';

class CodeBlock extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    code: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    tabPaneFooter: PropTypes.string
  }

  static defaultProps = {
    tabPaneFooter: null
  }

  static contextTypes = {
    trackEvent: PropTypes.func.isRequired
  }

  handleCopyCode = throttle(
    () => {
      this.context.trackEvent('copy:code-snippet', {
        path: window.location.pathname,
        url: window.location.toString(),
        title: document.title,
        referrer: document.referrer
      });
    },
    5000,
    { trailing: false }
  )

  render() {
    const { code, children, index, tabPaneFooter } = this.props;

    return (
      <div className={styles.codeBlock}>
        <div className={styles.codeSection}>
          <CopyButton small code={code} />
          <CodeHighlight>
            <pre
              className={styles.code}
              onCopy={this.handleCopyCode}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: children }}
            />
          </CodeHighlight>
        </div>
        {tabPaneFooter && (
          <div
            className="tab-pane-footer"
            dangerouslySetInnerHTML={{ __html: tabPaneFooter }}
          />
        )}
        <FeedbackSection index={index} />
      </div>
    );
  }
}


export default CodeBlock;
